// Hungarian translations with "tegező" (informal) tone

const translations = {
  admin: {
    // Login page
    login: {
      title: 'Admin Belépés',
      username: 'Felhasználónév',
      password: 'Jelszó',
      loginButton: 'Belépés',
      loggingIn: 'Belépés...',
      invalidCredentials: 'Hibás felhasználónév vagy jelszó'
    },
    
    // Dashboard
    dashboard: {
      title: 'Admin Panel',
      welcome: 'Üdv, {username}!',
      nav: {
        dashboard: 'Irányítópult',
        products: 'Termékek',
        pickupLocations: 'Átvételi pontok',
        orders: 'Rendelések',
        faqs: 'GYIK',
        adminUsers: 'Admin Felhasználók',
        profile: 'Profilom',
        mainPage: 'Főoldal'
      },
      logout: 'Kijelentkezés'
    },
    
    // Admin Users management
    adminUsers: {
      title: 'Admin Felhasználók',
      addAdmin: 'Új Admin Hozzáadása',
      createAdmin: 'Új Admin Felhasználó Létrehozása',
      id: 'ID',
      email: 'Email',
      username: 'Felhasználónév',
      name: 'Név',
      password: 'Jelszó',
      createdAt: 'Létrehozva',
      save: 'Admin Létrehozása',
      cancel: 'Mégse',
      loading: 'Betöltés...',
      error: 'Hiba történt'
    },
    
    // Profile management
    profile: {
      title: 'Profil Beállítások',
      profileInfo: 'Profil Információk',
      changePassword: 'Jelszó Módosítása',
      username: 'Felhasználónév',
      usernameNote: 'A felhasználónév nem módosítható',
      email: 'Email',
      name: 'Név',
      currentPassword: 'Jelenlegi Jelszó',
      newPassword: 'Új Jelszó',
      confirmPassword: 'Új Jelszó Megerősítése',
      updateProfile: 'Profil Frissítése',
      updatePassword: 'Jelszó Módosítása',
      loading: 'Betöltés...',
      profileUpdateSuccess: 'Profil sikeresen frissítve',
      profileUpdateError: 'Profil frissítése sikertelen',
      passwordUpdateSuccess: 'Jelszó sikeresen módosítva',
      passwordUpdateError: 'Jelszó módosítása sikertelen',
      passwordMismatch: 'Az új jelszavak nem egyeznek',
      passwordTooShort: 'A jelszónak legalább 6 karakter hosszúnak kell lennie'
    },
    
    // Dashboard home
    dashboardHome: {
      title: 'Irányítópult',
      summary: 'Összefoglaló',
      totalProducts: 'Összes termék',
      totalPickupLocations: 'Összes átvételi pont',
      totalOrders: 'Összes rendelés',
      recentOrders: 'Legutóbbi rendelések',
      noOrders: 'Nincsenek rendelések',
      viewAll: 'Összes megtekintése'
    },
    
    // Products management
    products: {
      title: 'Termékek kezelése',
      addProduct: 'Új termék',
      editProduct: 'Termék szerkesztése',
      deleteProduct: 'Termék törlése',
      productName: 'Termék neve',
      description: 'Leírás',
      price: 'Ár',
      imageUrl: 'Kép URL',
      uploadImage: 'Kép feltöltése',
      chooseImage: 'Kép kiválasztása',
      uploadingImage: 'Kép feltöltése...',
      imagePreview: 'Kép előnézet',
      imageUploaded: 'Kép sikeresen feltöltve',
      imageUploadError: 'Hiba történt a kép feltöltése közben',
      available: 'Elérhető',
      actions: 'Műveletek',
      save: 'Mentés',
      cancel: 'Mégse',
      confirmDelete: 'Biztosan törölni szeretnéd ezt a terméket?',
      productAdded: 'Termék sikeresen hozzáadva',
      productUpdated: 'Termék sikeresen frissítve',
      productDeleted: 'Termék sikeresen törölve'
    },
    
    // Pickup locations management
    pickupLocations: {
      title: 'Átvételi pontok kezelése',
      addLocation: 'Új átvételi pont',
      editLocation: 'Átvételi pont szerkesztése',
      deleteLocation: 'Átvételi pont törlése',
      locationName: 'Név',
      address: 'Cím',
      openingHours: 'Nyitvatartás',
      available: 'Elérhető',
      actions: 'Műveletek',
      save: 'Mentés',
      cancel: 'Mégse',
      confirmDelete: 'Biztosan törölni szeretnéd ezt az átvételi pontot?',
      locationAdded: 'Átvételi pont sikeresen hozzáadva',
      locationUpdated: 'Átvételi pont sikeresen frissítve',
      locationDeleted: 'Átvételi pont sikeresen törölve'
    },
    
    // Orders management
    orders: {
      title: 'Rendelések kezelése',
      orderDetails: 'Rendelés részletei',
      orderId: 'ID',
      orderNumber: 'Rendelés száma',
      customerName: 'Vevő neve',
      customerEmail: 'Vevő email',
      customerPhone: 'Vevő telefonszáma',
      pickupLocation: 'Átvételi pont',
      pickupDate: 'Átvétel dátuma',
      totalAmount: 'Végösszeg',
      status: 'Állapot',
      items: 'Tételek',
      product: 'Termék',
      quantity: 'Mennyiség',
      price: 'Ár',
      subtotal: 'Részösszeg',
      updateStatus: 'Állapot frissítése',
      deleteOrder: 'Rendelés törlése',
      save: 'Mentés',
      cancel: 'Mégse',
      confirmDelete: 'Biztosan törölni szeretnéd ezt a rendelést?',
      orderUpdated: 'Rendelés sikeresen frissítve',
      orderDeleted: 'Rendelés sikeresen törölve',
      noOrders: 'Nincsenek rendelések',
      filter: 'Szűrés',
      resetFilters: 'Szűrők törlése',
      startDate: 'Kezdő dátum',
      endDate: 'Záró dátum',
      actions: 'Műveletek',
      noPickupLocation: 'Nincs átvételi pont',
      noItems: 'Nincsenek tételek',
      statuses: {
        pending: 'Függőben',
        confirmed: 'Visszaigazolva',
        completed: 'Teljesítve',
        cancelled: 'Törölve'
      }
    },
    
    // FAQ management
    faqs: {
      title: 'GYIK kezelése',
      addFaq: 'Új GYIK',
      editFaq: 'GYIK szerkesztése',
      deleteFaq: 'GYIK törlése',
      question: 'Kérdés',
      answer: 'Válasz',
      order: 'Sorrend',
      active: 'Aktív',
      actions: 'Műveletek',
      save: 'Mentés',
      cancel: 'Mégse',
      confirmDelete: 'Biztosan törölni szeretnéd ezt a GYIK-et?',
      faqAdded: 'GYIK sikeresen hozzáadva',
      faqUpdated: 'GYIK sikeresen frissítve',
      faqDeleted: 'GYIK sikeresen törölve',
      reorderFaqs: 'Sorrend módosítása',
      reorderInstructions: 'Húzd a kérdéseket a kívánt sorrendbe',
      saveOrder: 'Sorrend mentése'
    },
    
    // Common
    common: {
      loading: 'Betöltés...',
      error: 'Hiba történt',
      noData: 'Nincs megjeleníthető adat',
      edit: 'Szerkesztés',
      delete: 'Törlés',
      view: 'Megtekintés',
      yes: 'Igen',
      no: 'Nem',
      back: 'Vissza',
      search: 'Keresés',
      filter: 'Szűrés',
      sort: 'Rendezés',
      itemsPerPage: 'Tételek oldalanként',
      page: 'Oldal',
      of: '/',
      next: 'Következő',
      previous: 'Előző',
      cancel: 'Mégse',
    }
  },
  
  // User-facing translations
  faq: {
    title: 'Gyakran Ismételt Kérdések',
    subtitle: 'Válaszok a leggyakrabban felmerülő kérdésekre',
    noFaqs: 'Jelenleg nincsenek GYIK-ek',
    expandAll: 'Összes kinyitása',
    collapseAll: 'Összes becsukása'
  }
};

export default translations;
